import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ActionFormBase } from '../form-action';

@Component({
    selector: 'app-action-form',
    templateUrl: './action-form.component.html',
    providers: [TranslatePipe],
    standalone: false
})
export class ActionFormComponent extends ActionFormBase<any> implements OnInit {

  @Input() formClass = '';
  @Input() formTitle = '';

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
